import { useContext } from 'react';
import { AccountContext } from 'contexts/account-context';

export type UseAccountValue = {
  name: string;
  setName: (name: string) => void;
};

export const useAccount = (): UseAccountValue => {
  const { name, setName } = useContext(AccountContext);

  return { name, setName };
};
